import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import { useTotemBasic } from "../../../../hooks/useCases/useTotemBasic"
import { useFormNew } from "../../../../hooks/useFormNew"
import { Button, Grid, MenuItem } from "@material-ui/core"

export const FormSubOpciones = ({ subOpcion, closeModal, opciones }) => {
    const { insert, update } = useTotemBasic()
    const { formValues, handleInputChange } = useFormNew({
        ...(subOpcion?.id ? { id: subOpcion.id } : {}),
        descripcion: subOpcion?.descripcion || "",
        idOpcion: subOpcion?.idOpcion || "",
    })
    const handleSubmit = () => subOpcion?.id ? update.subOpcion(formValues, closeModal) : insert.subOpcion(formValues, closeModal)
    return (
        <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextValidator
                        name="descripcion"
                        value={formValues.descripcion}
                        onChange={handleInputChange}
                        label="Descripcion"
                        fullWidth
                        validators={["required"]} />
                </Grid>
                <Grid item xs={12}>
                    <SelectValidator
                        fullWidth
                        label="Opcion"
                        name="idOpcion"
                        value={formValues.idOpcion}
                        onChange={handleInputChange}
                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                        validators={["required"]}
                        errorMessages={["Este campo es obligatorio"]}
                        style={{ color: '#000' }}
                    >
                        <MenuItem value={""}><em>Seleccione</em></MenuItem>
                        {opciones.map((e) => (
                            <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>
                        ))}
                    </SelectValidator>
                </Grid>
                <Grid item xs={12} gap={2} style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button color='secondary' onClick={closeModal}>CANCELAR</Button>
                    <Button color='primary' type='submit'>GUARDAR</Button>
                </Grid>

            </Grid>
        </ValidatorForm>
    )
}